import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesCustomFieldsManageRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-custom-fields-manage',
	path: '/secure/admin/ManageConfigurationScheme!default.jspa',
};
